<template>
  <div class="flex w-full" style="position:relative;">          
 <div v-if="!coverageIteration" class="w-full h-full flex items-center justify-center title">      
  {{$t(isAloDbMissionGlobalCoverage(missionGlobal)?"Simulation.NoCoverageIterationSelected":"Simulation.NoFormationIterationSelected")}}
 </div>       
 <div v-else-if="gliderKeys.length" class="d-flex flex-col w-full h-full" >      
   <v-tabs v-model="selectedGliderIdx" align-with-title class="flex-grow-0" >
     <v-tab v-for="(glider,idx) in gliderKeys" :key="glider"  :title="glider" >                  
           {{ glider }}                  
     </v-tab>                 
   </v-tabs>              
   <MissionDetailScienceGraphicsListGen v-if="finishedSimulation" :uiid="uiid" :isleft="isleft" :mission="coverageIteration.resultAloMission[gliderKeys[allGraphUiState.gliderIdx]]" :tabState="simulationUiState"  @selectGraph="selectGraph($event)" />      
 </div>          
 <div v-else class="w-full h-full flex flex-col mx-4 items-center justify-center title gap-2" >         
   <span>{{$t(stepTradKey)}}</span>
   <span>{{$t(stateTradKey)}}</span>            
   <v-progress-linear indeterminate color="primary" ></v-progress-linear>      
 </div>
</div>  
</template>
<script setup lang="ts">
 
 import { ref,computed, watch, nextTick } from 'vue'  
 import store from '@/store'  
 import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
 import {buildCoverageIterationUiStateId} from '@/models/ui/CoverageIterationUiState'
 import { CoverageState, getCoverageState, getCoverageStateTradKey } from '@/enum/CoverageState'
 import { CoverageStep, getCoverageStep, getCoverageStepTradKey } from '@/enum/CoverageStep'   
 import MissionDetailScienceGraphicsListGen from '@/components/mission/MissionDetailScienceGraphicsListGen.vue'
 import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
 import { isAloDbMissionGlobalCoverage } from '@/models/alodb/AloDbMissionGlobal'

 const props = defineProps<{
   isleft:boolean,
   uiid:string
 }>()

 
  
 const missionGlobal = computed(()=> store.myGetters.modifiedAdmMissionGlobal)    
 
 const simulation_uiid = computed(()=> buildSimulationUIStateId(missionGlobal.value.MIG_ID!,"detail")) 
 const coverage_uiid = computed(()=> buildCoverageStateId(missionGlobal.value.MIG_ID!,"detail")) 
 const coverageiteration_uiid = computed(()=> coverageState.value.selectedCoverageId?buildCoverageIterationUiStateId(coverageState.value.selectedCoverageId!,"detail"):null)     
 // const coverageIterationState = computed(()=> coverageiteration_uiid.value?store.myGetters.coverageIterationStateByUiid(coverageiteration_uiid.value):null)

 const allGraphUiState = computed(()=> store.myGetters.allGraphUiStateByUiid(props.uiid))
 const simulationUiState = computed(()=> store.myGetters.simulationUiStateByUiid(simulation_uiid.value))       
 const coverageState = computed(()=> store.myGetters.coverageStateByUiid(coverage_uiid.value))       
 const coverageIteration = computed(()=> coverageState.value.selectedCoverageId?store.myGetters.coverageIterationsById[coverageState.value.selectedCoverageId]:null)   
 const gliderKeys = computed(()=>Object.keys(coverageIteration.value?.resultMipJson || {}).filter(n => n.startsWith('GLIDER')))

 const finishedSimulation = computed( () => {
    return (coverageIteration.value?.COV_PROCESSING_STATE == CoverageState.finished || coverageIteration.value?.COV_PROCESSING_STATE == CoverageState.aborted) && coverageIteration.value?.COV_PROCESSING_STEP == CoverageStep.FinalSimulation
  })
 
 const selectedGliderIdx = computed({
   get() {
     return allGraphUiState.value?.gliderIdx ?? -1
   },
   set(value:number) {
     allGraphUiState.value!.gliderIdx = value
   }
 })

 const stateTradKey = computed(()=> getCoverageStateTradKey(getCoverageState(coverageIteration.value?.COV_PROCESSING_STATE))) 
 const stepTradKey = computed(()=> getCoverageStepTradKey(getCoverageStep(coverageIteration.value?.COV_PROCESSING_STEP)))

 async function selectGraph(graph:any){      
   await store.myActions.UI_NAVTO_DETAIL({cmp:'CoverageDetailScienceGraphics',uiid:simulation_uiid.value,isleft:!props.isleft,'label':graph.name})             
   //on attend que le composant soit créé
   nextTick(()=> {
     const tabsMission = !props.isleft? simulationUiState.value.tabsleft: simulationUiState.value.tabsright
     store.myActions.UI_SET_GRA_CONFIG({config:graph,uiid:tabsMission.selected})
   })
}

</script> 